import { ReactNode } from 'react';
import cx from 'classnames';
import { Portal } from '@cat-ecom/pcc-components';
import { ROOT_PORTALS } from 'constants/targets';
import styles from './fixed-container.module.scss';

interface FixedContainerProps {
  children: ReactNode;
  portalId?: string;
  spacerClassName?: string;
  containerClassName?: string;
}

export const FixedContainer = ({
  children,
  portalId,
  spacerClassName,
  containerClassName
}: FixedContainerProps) => {
  return (
    <Portal id={portalId ?? ROOT_PORTALS}>
      <>
        <div className={cx('mt-4', spacerClassName)} />
        <div
          className={cx(
            'position-fixed bottom-0 start-0 d-flex px-3 py-3 w-100 bg-body',
            styles['fixed-actions'],
            containerClassName
          )}
        >
          {children}
        </div>
      </>
    </Portal>
  );
};
